var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ng-green-data" }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title-row" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_setup.t("pageTitle"))),
          ]),
          _setup.isChangeLanguage
            ? _c(
                "div",
                { staticClass: "lang-switch" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "lang-select",
                      attrs: { size: "mini" },
                      model: {
                        value: _setup.lang,
                        callback: function ($$v) {
                          _setup.lang = $$v
                        },
                        expression: "lang",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "EN", value: "en" } }),
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c(_setup.DateTimeRangePicker, {
            staticClass: "picker",
            attrs: {
              "picker-type": "daterange",
              size: "mini",
              clearable: false,
              i18n: _setup.pickerI18n,
            },
            model: {
              value: _setup.dateRange,
              callback: function ($$v) {
                _setup.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _c(
            "div",
            { staticClass: "quick" },
            _vm._l(_setup.quickRangeOptions, function (item) {
              return _c(
                "el-button",
                {
                  key: item.key,
                  attrs: {
                    size: "mini",
                    type:
                      _setup.currentDateRangeKey === item.key
                        ? "primary"
                        : "default",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.applyQuickRange(item.key)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.loading,
              expression: "loading",
            },
          ],
          staticClass: "cards",
        },
        [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("overviewTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--1" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("totalProfit"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.overview.totalProfit))
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("usersTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--4" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("registrations"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatInt(_setup.stats.user.registerCount))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("firstDepositors"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _setup.formatInt(_setup.stats.user.firstDepositUsers)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("totalPlayerBalance"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.user.totalBalance))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("newUsers"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(_vm._s(_setup.formatInt(_setup.stats.user.newUsers))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("depositsTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--4" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("totalDepositAmount"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.deposit.totalAmount))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("depositUsers"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(_vm._s(_setup.formatInt(_setup.stats.deposit.users))),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("firstDepositors"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _setup.formatInt(_setup.stats.deposit.firstDepositUsers)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("depositFees"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(_vm._s(_setup.formatNgn(_setup.stats.deposit.fee))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("withdrawalsTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--2" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("totalWithdrawalAmount"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.withdraw.totalAmount))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("withdrawalFees"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(_vm._s(_setup.formatNgn(_setup.stats.withdraw.fee))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("gamesTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--2" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("gameWinLoss"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "value",
                    class: _setup.signClass(_setup.stats.game.winLose),
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _setup.formatSignedNgn(_setup.stats.game.winLose)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("betAmount"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(_vm._s(_setup.formatNgn(_setup.stats.game.betAmount))),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("promotionsTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--3" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("manualCredit"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _setup.formatNgn(_setup.stats.activity.manualUpScore)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("depositBonus"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.activity.depositBonus))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("platformBonus"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _setup.formatNgn(_setup.stats.activity.platformBonus)
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_setup.t("agentCommissionTitle"))),
            ]),
            _c("div", { staticClass: "metrics metrics--2" }, [
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("totalCommission"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.agent.totalCommission))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "metric" }, [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_setup.t("withdrawn"))),
                ]),
                _c("div", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_setup.formatNgn(_setup.stats.agent.withdrawn))
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }